export default {
  createSuccess: "Host created successfully!",
  createModal: {
    title: "Add New Host",
    namePlaceholder: "e.g., Villa Panorama",
    emailPlaceholder: "host@example.com",
    create: "Create Host",
  },
  detail: {
    roleLabel: "Host",
    statStructures: "Structures",
    loadDetail: "Loading host details...",
    loadError: "Failed to load host",
    toastStatusUpdated: "Host status updated",
    toastStatusError: "Failed to update host status",
    toastPasswordResetSent: "Password reset email sent to the host.",
    housesTitle: "Structures",
    noHouses: "No structures yet",
    activitiesTitle: "Activities ({{count}})",
    loadActivities: "Loading activities...",
    activitiesError: "Failed to load activities",
    noActivitiesTitle: "No activities",
    noActivitiesDesc: "This host has no activities yet",
  },
} as const;
